import {
  useEffect,
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Invoices() {

  const navigate = useNavigate();

  const [invoices,
    setInvoices] =
    useState([]);

  const [page,
    setPage] =
    useState(1);

  const [pages,
    setPages] =
    useState(1);

  const [search,
    setSearch] =
    useState("");

  useEffect(() => {
    loadInvoices();
  }, [page, search]);

  const loadInvoices =
    async () => {

      try {

        const res =
          await API.get(
            `/invoices?page=${page}&search=${search}`
          );

        setInvoices(
          res.data.invoices || []
        );

        setPages(
          res.data.pages || 1
        );

      } catch (err) {
        console.log(err);
      }

    };

  const deleteInvoice =
    async (id) => {

      if (
        !window.confirm(
          "Delete Invoice?"
        )
      ) return;

      try {

        await API.delete(
          `/invoices/${id}`
        );

        loadInvoices();

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      {/* HEADER */}

      <div
        className="
        flex
        flex-col
        md:flex-row
        md:justify-between
        md:items-center
        gap-4
        mb-6
        "
      >

        <h1
          className="
          text-3xl
          md:text-4xl
          font-bold
          "
        >
          Invoices
        </h1>

        {hasPermission("invoice.add") && (
          <button
            onClick={() =>
              navigate(
                "/admin/invoices/create"
              )
            }
            className="
          bg-yellow-500
          text-black
          px-5
          py-3
          rounded-xl
          font-semibold
          "
          >
            Create Invoice
          </button>
        )}

      </div>

      {/* SEARCH */}

      <input
        type="text"
        placeholder="Search Invoice..."
        value={search}
        onChange={(e) =>
          setSearch(
            e.target.value
          )
        }
        className="
        w-full
        md:w-96
        p-3
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        mb-6
        "
      />

      {/* MOBILE */}

      <div className="md:hidden space-y-4">

        {invoices.map(
          (item) => (

            <div
                key={item.id}
                className="
                bg-[#111]
                rounded-2xl
                border
                border-yellow-500/10
                p-4
                shadow-lg
                "
            >

                <div className="flex justify-between">
                    <span className="text-gray-400">
                        Invoice
                    </span>

                    <span className="font-semibold">
                        {item.invoice_no}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Customer
                    </span>

                    <span className="font-medium">
                        {item.customer_name}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Date
                    </span>

                    <span>
                        {new Date(item.invoice_date).toLocaleDateString()}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Payment Type
                    </span>

                    <span>
                        {item.payment_type}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Grand Total
                    </span>

                    <span className="font-bold text-green-400">
                        ₹{Number(item.grand_total).toFixed(2)}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Paid
                    </span>

                    <span className="text-green-400">
                        ₹{Number(item.paid_amount).toFixed(2)}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Due
                    </span>

                    <span className="text-red-400 font-semibold">
                        ₹{Number(item.remaining_amount).toFixed(2)}
                    </span>
                </div>

                <div className="flex justify-between mt-2">
                    <span className="text-gray-400">
                        Status
                    </span>

                    <span
                        className={`px-3 py-1 rounded-full text-xs font-bold
                        ${
                            item.payment_status === "paid"
                                ? "bg-green-500/20 text-green-400"
                                : item.payment_status === "partial"
                                ? "bg-yellow-500/20 text-yellow-400"
                                : "bg-red-500/20 text-red-400"
                        }`}
                    >
                        {item.payment_status}
                    </span>
                </div>

                <div className="grid grid-cols-2 gap-2 mt-5">

                    {hasPermission("invoice.view") && (
                        <button
                            onClick={() =>
                                navigate(`/admin/invoices/view/${item.id}`)
                            }
                            className="py-2 rounded-lg bg-blue-600"
                        >
                            View
                        </button>
                    )}

                    {hasPermission("invoice.edit") && (
                        <button
                            onClick={() =>
                                navigate(`/admin/invoices/edit/${item.id}`)
                            }
                            className="py-2 rounded-lg bg-yellow-500 text-black"
                        >
                            Edit
                        </button>
                    )}

                    {item.remaining_amount > 0 &&
                        hasPermission("invoice.add") && (
                            <button
                                onClick={() =>
                                    navigate(`/admin/invoices/payment/${item.id}`)
                                }
                                className="py-2 rounded-lg bg-green-600"
                            >
                                Collect
                            </button>
                    )}

                    {hasPermission("invoice.delete") && (
                        <button
                            onClick={() =>
                                deleteInvoice(item.id)
                            }
                            className="py-2 rounded-lg bg-red-600"
                        >
                            Delete
                        </button>
                    )}

                </div>

            </div>

          )
        )}

      </div>

      {/* DESKTOP */}

      <div
        className="
        hidden
        md:block
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
      >

        <div className="overflow-x-auto">

          <table
            className="
            w-full
            "
          >

            <thead>

              <tr
                className="
                border-b
                border-yellow-500/20
                "
              >

                <th className="p-4 text-left">
                  ID
                </th>

                <th className="p-4 text-left">
                  Invoice No
                </th>

                <th className="p-4 text-left">
                  Customer
                </th>

                <th className="p-4 text-center">
                  Date
                </th>

                <th className="p-4 text-center">
                  Payment
                </th>

                <th className="p-4 text-center">
                  Total
                </th>

                <th className="p-4 text-center">
                  Paid
                </th>

                <th className="p-4 text-center">
                  Due
                </th>

                <th className="p-4 text-center">
                  Status
                </th>

                <th className="p-4 text-center">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {invoices.map(
                (item) => (

                  <tr
                    key={item.id}
                    className="
                    border-b
                    border-yellow-500/10
                    "
                  >

                    <td className="p-4">
                      {item.id}
                    </td>

                    <td className="p-4">
                      {item.invoice_no}
                    </td>

                    <td className="p-4">
                      {item.customer_name}
                    </td>

                    <td className="p-4 text-center">
                      {new Date(item.created_at).toLocaleString()}
                    </td>

                    <td className="p-4 text-center">
                      {item.payment_type}
                    </td>

                    <td
                      className="
                      p-4
                      text-center
                      text-green-400
                      font-semibold
                      "
                    >
                      ₹
                      {item.grand_total}
                    </td>

                    <td className="p-4 text-center">
                      {item.paid_amount}
                    </td>

                    <td className="p-4 text-center">
                      {item.remaining_amount}
                    </td>

                    <td>
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-bold
                        ${item.payment_status === "paid"
                            ? "bg-green-500/20 text-green-400"
                            : item.payment_status === "partial"
                              ? "bg-yellow-500/20 text-yellow-400"
                              : "bg-red-500/20 text-red-400"
                          }`}
                      >
                        {item.payment_status}
                      </span>
                    </td>

                    <td className="p-4">

                      <div
                        className="
                        flex
                        justify-center
                        gap-2
                        "
                      >

                        {hasPermission("invoice.view") && (
                          <button
                            onClick={() =>
                              navigate(
                                `/admin/invoices/view/${item.id}`
                              )
                            }
                            className="
                          px-4
                          py-2
                          bg-blue-500
                          rounded-lg
                          "
                          >
                            View
                          </button>
                        )}

                        {hasPermission("invoice.edit") && (
                          <button
                            onClick={() =>
                              navigate(`/admin/invoices/edit/${item.id}`)
                            }
                            className="
                              px-4
                              py-2
                              bg-yellow-500
                              text-black
                              rounded-lg
                              "
                          >
                            Edit
                          </button>
                        )}

                        {item.remaining_amount > 0 &&
                          hasPermission("invoice.add") && (

                            <button
                              onClick={() =>
                                navigate(
                                  `/admin/invoices/payment/${item.id}`
                                )
                              }
                              className="
                              px-4
                              py-2
                              bg-green-600
                              rounded-lg
                              "
                            >
                              Collect
                            </button>

                          )}

                        {hasPermission("invoice.delete") && (
                          <button
                            onClick={() =>
                              deleteInvoice(
                                item.id
                              )
                            }
                            className="
                          px-4
                          py-2
                          bg-red-500
                          rounded-lg
                          "
                          >
                            Delete
                          </button>
                        )}

                      </div>

                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      </div>

      {/* PAGINATION */}

      <div
        className="
        flex
        gap-2
        mt-6
        flex-wrap
        "
      >

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(
              page - 1
            )
          }
          className="
          px-4
          py-2
          rounded-lg
          bg-[#111]
          "
        >
          Back
        </button>

        {[...Array(pages)]
          .map((_, i) => (

            <button
              key={i}
              onClick={() =>
                setPage(
                  i + 1
                )
              }
              className={`
              px-4
              py-2
              rounded-lg

              ${page === i + 1
                  ? "bg-yellow-500 text-black"
                  : "bg-[#111]"
                }
            `}
            >
              {i + 1}
            </button>

          ))}

        <button
          disabled={
            page === pages
          }
          onClick={() =>
            setPage(
              page + 1
            )
          }
          className="
          px-4
          py-2
          rounded-lg
          bg-[#111]
          "
        >
          Next
        </button>

      </div>

    </div>
  );
}

export default Invoices;